import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

/* C9 — `compact` is opt-in (default false, preserving the original full
   card — icon, title, description, "Open" link — exactly as-is for any
   future consumer) rather than changing this component's only existing
   behavior outright. Profile.jsx passes compact=true so its 5 settings
   tiles shrink to just an icon + name in a 2-column grid instead of a
   stack of full-width cards. `desc` still gets passed through as the
   tile's title attribute in compact mode, so the description isn't lost
   entirely — just not shown inline anymore. */
export function HubPage({ eyebrow, title, subtitle, tiles, testid, compact = false }) {
  const { tx, t: tr } = useLanguage();
  return (
    <div className="max-w-4xl mx-auto space-y-6" data-testid={testid}>
      <header>
        <div className="text-xs uppercase tracking-[0.22em] text-gold-600 font-semibold">{eyebrow}</div>
        <h1 className="mt-1 font-display font-semibold text-4xl text-forest-700">{title}</h1>
        {subtitle && <p className="mt-2 text-foreground/70">{subtitle}</p>}
      </header>
      <div className={compact ? "grid grid-cols-2 gap-3" : "grid gap-4"}>
        {tiles.map((t) => (
          compact ? (
            <Link
              key={t.to + t.label}
              to={t.to}
              title={tx(t.desc)}
              className="hifz-card hifz-card-hover flex flex-col items-center text-center gap-2 py-5"
              data-testid={t.testid}
            >
              <div className="h-11 w-11 rounded-xl bg-sand-200 grid place-items-center text-forest-700">
                <t.icon className="h-5 w-5" />
              </div>
              <div className="font-display font-semibold text-sm text-forest-700">{tx(t.label)}</div>
            </Link>
          ) : (
            <Link key={t.to + t.label} to={t.to} className="hifz-card hifz-card-hover group" data-testid={t.testid}>
              <div className="h-11 w-11 rounded-xl bg-sand-200 grid place-items-center text-forest-700 group-hover:scale-105 transition-transform">
                <t.icon className="h-5 w-5" />
              </div>
              <div className="mt-4 font-display font-semibold text-forest-700">{tx(t.label)}</div>
              <p className="mt-1 text-xs text-muted-foreground leading-relaxed">{tx(t.desc)}</p>
              <div className="mt-3 text-xs text-forest-700 inline-flex items-center gap-1 font-medium">
                {tr("hubPage.open")} <ChevronRight className="h-3 w-3 group-hover:translate-x-0.5 transition-transform" />
              </div>
            </Link>
          )
        ))}
      </div>
    </div>
  );
}
